// Material UI components

import React, { Component } from 'react';
import firebase from '../firebase';

import {
	Avatar,
	Button,
	CircularProgress,
	Container,
	CssBaseline,
	Grid,
	Link,
	TextField,
	Typography
 } from '@mui/material';

import { withStyles } from '@mui/styles';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';


const styles = (theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		// color: 'grey'
		color: theme.palette.primary.main
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.primary.main
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	progess: {
		position: 'absolute'
	}
});

class login extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			password: '',
			errors: [],
			loading: false
		};
	}

	// componentWillReceiveProps(nextProps) {
	// 	if (nextProps.UI.errors) {
	// 		this.setState({
	// 			errors: nextProps.UI.errors
	// 		});
	// 	}
	// }

	handleChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		});
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		this.setState({ loading: true });

		const { email, password } = this.state;
		try {
				const result = await firebase
					.auth()
					.signInWithEmailAndPassword(email, password);

				const token = await result.user.getIdToken();

				localStorage.setItem('AuthToken', `Bearer ${token}`);

				this.setState({ loading: false });
				this.props.history.push('/');
			} catch (error) {
				this.setState({
					errors: { general: error.message },
					loading: false
				});
			}
		
	};

	render() {
		const { classes } = this.props;
		const { errors, loading } = this.state;

		const resume = ( localStorage.getItem('TokenExpiry') !== null) ? (
			<div>
				<h3>Your session expired. Please login again:</h3>
			</div>
		)
		 : ''

		return (
			<Container component="main" maxWidth="xs">
				<CssBaseline />
				<div className={classes.paper}>
					{resume}
					<Avatar className={classes.avatar}>
						<LockOutlinedIcon />
					</Avatar>
					<Typography component="h1" variant="h5">
						Login
					</Typography>
					<form className={classes.form} noValidate>
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							id="email"
							label="Email Address"
							name="email"
							autoComplete="email"
							autoFocus
							helperText={errors.email}
							error={errors.email ? true : false}
							onChange={this.handleChange}
						/>
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							name="password"
							label="Password"
							type="password"
							id="password"
							autoComplete="current-password"
							helperText={errors.password}
							error={errors.password ? true : false}
							onChange={this.handleChange}
						/>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							className={classes.submit}
							onClick={this.handleSubmit}
							disabled={loading || !this.state.email || !this.state.password}
						>
							Sign In
							{loading && <CircularProgress size={30} className={classes.progess} />}
						</Button>
						{/* <Grid container>
							<Grid item>
								<Link href="signup" variant="body2">
									{"Sign Up as new user"}
								</Link>
							</Grid>
						</Grid> */}
						{errors.general && (
							<Typography variant="body2" className={classes.customError}>
								{errors.general}
							</Typography>
						)}
					</form>
				</div>
			</Container>
		);
	}
}

export default withStyles(styles)(login);